
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LandingFormData } from "../hooks/useLandingForm";

interface PersonalInfoSectionProps {
  formData: LandingFormData;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const PersonalInfoSection = ({ formData, handleChange }: PersonalInfoSectionProps) => {
  return (
    <>
      <p className="text-sm text-muted-foreground mb-4">Please provide your real information to access the product catalog</p>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="firstName">First Name *</Label>
          <Input
            id="firstName"
            name="firstName"
            type="text"
            required
            value={formData.firstName}
            onChange={handleChange}
            placeholder="Your first name"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="lastName">Last Name *</Label>
          <Input
            id="lastName"
            name="lastName"
            type="text"
            required
            value={formData.lastName}
            onChange={handleChange}
            placeholder="Your last name"
          />
        </div>
      </div>
    </>
  );
};

export default PersonalInfoSection;
